import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import ElevatedPaper from "../../../../components/ElevatedPaper";

const SettingsLayout = () => {
  return (
    <ElevatedPaper>
      <Box display="flex" flexDirection="column" height="100%">
        <Outlet />
      </Box>
    </ElevatedPaper>
  );
};

export default SettingsLayout;
